// src/components/Landing.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import styled from "styled-components";

// Sections
import TopNavbar from "../Navbar/Navbar";
import Sidebar from "../Navbar/Sidebar";
import Footer from "../Navbar/Footer";
import Home from "../Section/Home";
import Service from "../Section/Services";
import ServiceDetail from "../../Elements/ServiceDetails"
import About from "../Section/about";
import Booking from "../Section/Booking";
import ServicePage from "../Section/Booking"; // Booking component
import ScrollToTop from "./ScroolTop"; // ScrollToTop component
import ContactPage from "../Section/contact";
import BlogPage from "../Section/Blog";
import BlogDetail from "../../Elements/BlogDetail";
import ResourcePage from "../../Elements/Resources";
import Event from "../Section/Event";
import CheckoutButton from "../../Elements/CheckoutButton";
import GoogleAnalytics from "../../GoogleAnalytics";
import Article from "../../Elements/Article"
const MainContent = styled.div`
  margin-top: 80px; // Adjust this based on your navbar height
  padding: 0 5px; // Optional padding for horizontal spacing
`;

export default function Landing() {
  return (
    <>
      <TopNavbar />
      {/* <Sidebar /> */}
      <ScrollToTop />
      <GoogleAnalytics />
      <MainContent>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Service />} />
          <Route path="/service/:serviceName" element={<ServicePage />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="events" element={<Event/>}/>
          <Route path="/booking" element={<Booking/>}/>
          <Route path="/blogs" element={<BlogPage/>}/>
          <Route path="/blogs/:link" element={<BlogDetail />} />
          <Route path="resources" element={<ResourcePage/>}/>
          <Route path="articles" element={<Article/>}/>
          <Route path="/contact" element={<ContactPage/>}/>
          <Route path="/checkout" element={<CheckoutButton/>}/>
          </Routes>
      </MainContent>
      <Footer />
    </>
  );
}
